import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const AdmissionIcon = (): JSX.Element => (
  <SVGUniqueID>
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={32} height={32} rx={16} fill="#FFCB4A" />
      <g clipPath="url(#a)">
        <path
          d="M16 25.938c5.488 0 9.938-4.45 9.938-9.938S21.488 6.063 16 6.063 6.063 10.512 6.063 16s4.449 9.938 9.937 9.938"
          fill="#fff"
        />
        <path
          d="M23.545 22.465A9.9 9.9 0 0 1 16 25.937 9.935 9.935 0 0 1 6.063 16a9.9 9.9 0 0 1 3.705-7.74 19.2 19.2 0 0 0 2.966 6.622 19.44 19.44 0 0 0 7.612 6.413c1.02.48 2.089.874 3.199 1.17"
          fill="#EFEFEF"
        />
        <path
          d="M16 4.563C9.685 4.563 4.563 9.685 4.563 16S9.685 27.438 16 27.438 27.438 22.315 27.438 16 22.315 4.563 16 4.563m0 21.375A9.935 9.935 0 0 1 6.063 16 9.935 9.935 0 0 1 16 6.063 9.935 9.935 0 0 1 25.938 16 9.935 9.935 0 0 1 16 25.938"
          fill="#FCDA35"
        />
        <path
          d="M10.752 21.813h.371a.564.564 0 0 0 .564-.564v-5.997a.564.564 0 0 0-.564-.565h-.371a.564.564 0 0 0-.565.565v5.996c0 .312.253.564.565.564"
          fill="#7F1D1D"
        />
        <path
          d="M17.313 14.688v-3.376a1.125 1.125 0 1 0-2.25 0v.75a2.63 2.63 0 0 1-1.844 2.507 1.12 1.12 0 0 0-.781 1.07v5.047c0 .622.504 1.127 1.126 1.127h5.835c.532 0 .992-.373 1.102-.894l1.025-4.873a1.126 1.126 0 0 0-1.102-1.358z"
          fill="#B45656"
        />
        <path
          d="M25.169 22.829A11.4 11.4 0 0 1 16 27.437C9.685 27.438 4.563 22.316 4.563 16c0-3.881 1.935-7.309 4.89-9.375.082.555.183 1.099.315 1.635A9.9 9.9 0 0 0 6.062 16 9.935 9.935 0 0 0 16 25.938a9.9 9.9 0 0 0 7.545-3.473q.8.218 1.624.364"
          fill="#FACA00"
        />
        <path
          d="M20.346 21.295a1.13 1.13 0 0 1-.948.518h-5.835a1.123 1.123 0 0 1-1.126-1.125V15.64c0-.288.11-.555.297-.757a19.44 19.44 0 0 0 7.612 6.412"
          fill="#7F1D1D"
        />
        <path
          d="M16 27.625C9.59 27.625 4.375 22.41 4.375 16S9.59 4.375 16 4.375 27.625 9.59 27.625 16 22.41 27.625 16 27.625M16 4.75C9.797 4.75 4.75 9.797 4.75 16S9.797 27.25 16 27.25 27.25 22.203 27.25 16 22.203 4.75 16 4.75"
          fill="#09092D"
        />
        <path
          d="M11.124 22h-.372a.75.75 0 0 1-.752-.751v-5.997c0-.415.337-.752.752-.752h.371c.415 0 .752.337.752.752v5.996a.75.75 0 0 1-.751.752m-.373-7.125a.377.377 0 0 0-.376.377v5.996c0 .208.17.377.377.377h.371c.208 0 .377-.17.377-.377v-5.997a.377.377 0 0 0-.377-.376zM19.399 22h-5.834c-.725 0-1.314-.59-1.314-1.314V15.64a1.3 1.3 0 0 1 .913-1.249 2.43 2.43 0 0 0 1.712-2.328v-.75c0-.723.589-1.312 1.313-1.312.723 0 1.312.589 1.312 1.313V14.5h2.924c.399 0 .77.177 1.021.486s.347.71.265 1.098l-1.026 4.873A1.32 1.32 0 0 1 19.399 22m-3.21-11.625a.94.94 0 0 0-.938.938v.75a2.8 2.8 0 0 1-1.976 2.685.93.93 0 0 0-.649.891v5.047a.94.94 0 0 0 .939.939h5.834a.94.94 0 0 0 .919-.745l1.026-4.873a.936.936 0 0 0-.919-1.132h-3.111a.19.19 0 0 1-.188-.187v-3.376a.94.94 0 0 0-.937-.937"
          fill="#09092D"
        />
        <path
          d="M16 26.125c-5.583 0-10.125-4.542-10.125-10.125S10.417 5.875 16 5.875c1.663 0 3.312.412 4.77 1.191a.188.188 0 0 1-.177.33A9.8 9.8 0 0 0 16 6.251c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75a9.7 9.7 0 0 0-1.672-5.461.187.187 0 1 1 .31-.21A10.07 10.07 0 0 1 26.125 16c0 5.583-4.542 10.125-10.125 10.125"
          fill="#09092D"
        />
        <path
          d="M23.144 9.28a.2.2 0 0 1-.135-.057 10 10 0 0 0-1.555-1.306.187.187 0 1 1 .21-.31 10.2 10.2 0 0 1 1.615 1.355.187.187 0 0 1-.135.318"
          fill="#09092D"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M4 4h24v24H4z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { AdmissionIcon };
